import css from "styled-jsx/css";

export default css`
  .ecobill__fake {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    &--box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-radius: 1rem;
      border: 1px solid #dddddd;
      padding: 1rem;
      gap: 1rem;
      &--title {
        height: 38px;
        width: 50%;
      }
      &--switch {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        padding: 1rem 0;
        border-bottom: 1px solid #f3eeea;
        &--info {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          width: 80%;
          &--label {
            height: 18px;
            width: 80px;
          }
          &--text {
            height: 18px;
            width: 90%;
          }
        }
      }
      &--switch:last-child {
        border-bottom: 0;
      }
    }
    &--text {
      height: 18px;
      width: 100%;
    }
  }

  @media screen and (min-width: 1024px) {
    .ecobill__fake {
      width: 60%;
    }
  }
`;
